import React from "react";
import { formatInUserTimezone } from "../../utils/timezone";

function NextActivitiesLog({
  active,
  history,
  onAdd,
  onComplete,
  onSuspend,
  onReopen,
  onLogActivity,
}) {
  const items = history || [];

  return (
    <div className="next-activities-log">
      <div className="next-activities-log-header">
        <div className="next-activities-log-title">
          <i className="fas fa-calendar-check" /> Next Activities
        </div>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onAdd}
        >
          <i className="fas fa-plus" /> Add Next
        </button>
      </div>

      {active && (
        <div className="next-activity-item next-activity-item-active">
          <div className="next-activity-icon">
            <i className="fas fa-bullseye" />
          </div>
          <div className="next-activity-content">
            <div className="next-activity-line-1">
              <span className="next-activity-status-pill active">Active</span>
              <span className="next-activity-type">
                {active.activity_type}
              </span>
            </div>
            <div className="next-activity-line-2">
              {formatInUserTimezone(active.planned_date)}
            </div>
            {active.notes && (
              <div className="next-activity-line-3">{active.notes}</div>
            )}
            <div className="next-activity-actions">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => onComplete(active)}
              >
                <i className="fas fa-check" /> Mark Done
              </button>
              <button
                type="button"
                className="btn btn-sm btn-secondary"
                onClick={() => onSuspend(active)}
              >
                <i className="fas fa-pause" /> Suspend
              </button>
            </div>
          </div>
        </div>
      )}

      {items.length === 0 && !active && (
        <p className="text-muted">No Next Activities recorded yet.</p>
      )}

      {items
        .filter((r) => r.next_activity_id !== active?.next_activity_id)
        .map((item) => {
          const isCompleted = item.status === "Completed";
          const isSuspended = item.status === "Suspended";
          const isSystemAuto =
            isCompleted && item.completed_reason === "system_auto";

          let statusLabel = item.status;
          let statusClass = "inactive";

          if (isCompleted) {
            statusLabel = "Completed";
            statusClass = "completed";
          } else if (isSuspended) {
            statusLabel = "Suspended";
            statusClass = "suspended";
          } else if (item.status === "Overdue") {
            statusLabel = "Overdue";
            statusClass = "overdue";
          }

          return (
            <div
              className={`next-activity-item next-activity-item-${statusClass}`}
              key={item.next_activity_id}
            >
              <div className="next-activity-icon">
                <i
                  className={`fas fa-${
                    isCompleted
                      ? "check-circle"
                      : isSuspended
                        ? "pause-circle"
                        : "clock"
                  }`}
                />
              </div>
              <div className="next-activity-content">
                <div className="next-activity-line-1">
                  <span className={`next-activity-status-pill ${statusClass}`}>
                    {statusLabel}
                  </span>
                  <span className="next-activity-type">
                    {item.activity_type}
                  </span>
                </div>
                <div className="next-activity-line-2">
                  Planned: {formatInUserTimezone(item.planned_date)}
                </div>
                {item.notes && (
                  <div className="next-activity-line-3">{item.notes}</div>
                )}
                {item.completed_reason && (
                  <div className="next-activity-line-4 next-activity-reason">
                    Reason: {item.completed_reason}
                    {item.remark ? ` — ${item.remark}` : ""}
                  </div>
                )}

                {isSystemAuto && (
                  <div className="next-activity-actions">
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary"
                      onClick={() => onLogActivity(item)}
                    >
                      <i className="fas fa-clipboard-check" /> Log activity
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary"
                      onClick={() => onReopen(item)}
                    >
                      <i className="fas fa-undo" /> Reopen
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default NextActivitiesLog;